import React from "react";
import { toast } from "react-toastify";
import SoporteToolsAPI from "../../services/SoporteTools";
import AcceptModal from "../util/acceptModal/AcceptModal";
import "./caffenioStyle.css";

export default class HorariosPuntoVenta extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      caffenio: null,
      config: {
        driveVenueId: 0,
        latitud: "",
        longitud: "",
        horarioLunesViernes: "",
        horarioSabado: "",
        horarioDomingo: "",
        horarioLunesViernesStartHour: "",
        horarioLunesViernesStartMinute: "",
        horarioLunesViernesEndHour: "",
        horarioLunesViernesEndMinute: "",
        horarioLunesViernesCerrado: false,
        horarioSabadoStartHour: "",
        horarioSabadoStartMinute: "",
        horarioSabadoEndHour: "",
        horarioSabadoEndMinute: "",
        horarioSabadoCerrado: false,
        horarioDomingoStartHour: "",
        horarioDomingoStartMinute: "",
        horarioDomingoEndHour: "",
        horarioDomingoEndMinute: "",
        horarioDomingoCerrado: false,
        ciudad: "",
        estado: "",
        direccion: "",
        mobileEnabled: false,
        driveCartActivated: false,
        caffenioType: "1",
      },
      schedules: [],
      loadingHorarios: false,
      showEditScheduleModal: false,
      editingSchedule: null,
      editStartTime: "06:00:00",
      editEndTime: "22:00:00",
      showToggleDayConfirm: false,
      toggleDayData: null,
    };
  }

  componentDidMount() {
    if (!this.props.location.state || !this.props.location.state.caffenio) {
      this.props.history.push("/puntos-de-venta");
      return;
    }

    const caffenio = this.props.location.state.caffenio;
    const config = {
      driveVenueId: 0,
      latitud: "",
      longitud: "",
      horarioLunesViernes: "",
      horarioSabado: "",
      horarioDomingo: "",
      horarioLunesViernesStartHour: "",
      horarioLunesViernesStartMinute: "",
      horarioLunesViernesEndHour: "",
      horarioLunesViernesEndMinute: "",
      horarioLunesViernesCerrado: false,
      horarioSabadoStartHour: "",
      horarioSabadoStartMinute: "",
      horarioSabadoEndHour: "",
      horarioSabadoEndMinute: "",
      horarioSabadoCerrado: false,
      horarioDomingoStartHour: "",
      horarioDomingoStartMinute: "",
      horarioDomingoEndHour: "",
      horarioDomingoEndMinute: "",
      horarioDomingoCerrado: false,
      ciudad: "",
      estado: "",
      direccion: "",
      mobileEnabled: false,
      driveCartActivated: false,
      caffenioType: "",
    };

    this.setState(
      {
        caffenio,
        config,
        schedules: [],
      },
      () => this.loadHorariosFromApi(this.getDriveId(caffenio)),
    );
  }

  getAny = (obj, keys) => {
    for (let index = 0; index < keys.length; index++) {
      const key = keys[index];
      if (
        obj &&
        obj[key] !== undefined &&
        obj[key] !== null &&
        obj[key] !== ""
      ) {
        return obj[key];
      }
    }
    return "";
  };

  buildAddressText = (caffenio) => {
    const street = this.getAny(caffenio, ["calle", "street"]);
    const number = this.getAny(caffenio, ["numero", "number"]);
    const suburb = this.getAny(caffenio, ["colonia", "suburb"]);
    const city = this.getAny(caffenio, ["municipio", "ciudad"]);
    const state = this.getAny(caffenio, ["estado"]);
    const parts = [street, number, suburb, city, state].filter(Boolean);
    return parts.join(", ");
  };

  getDriveId = (caffenio) => {
    return this.getAny(caffenio, ["id", "DriveId", "caffenioId"]);
  };

  getDayName = (dayOfWeek) => {
    const names = {
      1: "Domingo",
      2: "Lunes",
      3: "Martes",
      4: "Miercoles",
      5: "Jueves",
      6: "Viernes",
      7: "Sabado",
    };
    return names[dayOfWeek] || "";
  };

  normalizeVenueType = (value, fallback = "1") => {
    if (value === undefined || value === null || value === "") {
      return fallback;
    }

    const numeric = parseInt(value, 10);
    if (isNaN(numeric)) {
      return fallback;
    }

    if (numeric < 1 || numeric > 4) {
      return fallback;
    }

    return `${numeric}`;
  };

  normalizeTime = (value) => {
    if (!value) return "06:00:00";
    const str = `${value}`.trim();
    if (/^\d{2}:\d{2}:\d{2}$/.test(str)) return str;
    if (/^\d{2}:\d{2}$/.test(str)) return `${str}:00`;
    return "06:00:00";
  };

  parseRangeToTimes = (
    rangeText,
    fallbackStart = "06:00:00",
    fallbackEnd = "22:00:00",
  ) => {
    if (
      !rangeText ||
      typeof rangeText !== "string" ||
      !rangeText.includes("-")
    ) {
      return { StartTime: fallbackStart, EndTime: fallbackEnd };
    }

    const parts = rangeText.split("-").map((p) => p.trim());
    if (parts.length !== 2) {
      return { StartTime: fallbackStart, EndTime: fallbackEnd };
    }

    const parseTimeText = (text) => {
      const twentyFour = text.match(/^(\d{1,2}):(\d{2})(:(\d{2}))?$/);
      if (twentyFour) {
        let hour = parseInt(twentyFour[1], 10);
        const minute = twentyFour[2];
        const second = twentyFour[4] || "00";
        if (hour >= 0 && hour <= 23) {
          const hh = `${hour}`.padStart(2, "0");
          return `${hh}:${minute}:${second}`;
        }
      }

      const match = text.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
      if (!match) return null;
      let hour = parseInt(match[1], 10);
      const minute = match[2];
      const meridiem = match[3].toUpperCase();

      if (meridiem === "AM") {
        if (hour === 12) hour = 0;
      } else {
        if (hour !== 12) hour += 12;
      }

      const hh = `${hour}`.padStart(2, "0");
      return `${hh}:${minute}:00`;
    };

    const start = parseTimeText(parts[0]) || fallbackStart;
    const end = parseTimeText(parts[1]) || fallbackEnd;

    return { StartTime: start, EndTime: end };
  };

  toMeridiemTime = (hhmmss) => {
    const value = this.normalizeTime(hhmmss);
    const [hourText, minuteText] = value.split(":");
    const hour = parseInt(hourText, 10);
    const meridiem = hour >= 12 ? "PM" : "AM";
    const normalizedHour = hour % 12 === 0 ? 12 : hour % 12;
    return `${`${normalizedHour}`.padStart(2, "0")}:${minuteText} ${meridiem}`;
  };

  formatRangeForInput = (start, end) => {
    return `${this.toMeridiemTime(start)} - ${this.toMeridiemTime(end)}`;
  };

  hasTimeValue = (value) => {
    return value !== undefined && value !== null && `${value}`.trim() !== "";
  };

  hasStoredRange = (start, end) => {
    return this.hasTimeValue(start) && this.hasTimeValue(end);
  };

  isClosedRange = (start, end) => {
    return (
      this.normalizeTime(start) === "00:00:00" &&
      this.normalizeTime(end) === "00:00:00"
    );
  };

  getHorarioPartMap = (field) => {
    if (field === "horarioLunesViernes") {
      return {
        startHour: "horarioLunesViernesStartHour",
        startMinute: "horarioLunesViernesStartMinute",
        endHour: "horarioLunesViernesEndHour",
        endMinute: "horarioLunesViernesEndMinute",
        closed: "horarioLunesViernesCerrado",
      };
    }

    if (field === "horarioSabado") {
      return {
        startHour: "horarioSabadoStartHour",
        startMinute: "horarioSabadoStartMinute",
        endHour: "horarioSabadoEndHour",
        endMinute: "horarioSabadoEndMinute",
        closed: "horarioSabadoCerrado",
      };
    }

    return {
      startHour: "horarioDomingoStartHour",
      startMinute: "horarioDomingoStartMinute",
      endHour: "horarioDomingoEndHour",
      endMinute: "horarioDomingoEndMinute",
      closed: "horarioDomingoCerrado",
    };
  };

  getDefaultHorarioParts = (field) => {
    if (field === "horarioDomingo") {
      return {
        startHour: "07",
        startMinute: "00",
        endHour: "10",
        endMinute: "00",
      };
    }

    return {
      startHour: "06",
      startMinute: "00",
      endHour: "10",
      endMinute: "00",
    };
  };

  formatTwoDigits = (value) => {
    return `${value}`.padStart(2, "0").slice(-2);
  };

  extractHorarioPartsFromTimes = (field, startTime, endTime) => {
    const defaults = this.getDefaultHorarioParts(field);
    const startText = this.toMeridiemTime(startTime);
    const endText = this.toMeridiemTime(endTime);
    const startMatch = startText.match(/^(\d{2}):(\d{2})\s(AM|PM)$/i);
    const endMatch = endText.match(/^(\d{2}):(\d{2})\s(AM|PM)$/i);

    return {
      startHour: startMatch ? startMatch[1] : defaults.startHour,
      startMinute: startMatch ? startMatch[2] : defaults.startMinute,
      endHour: endMatch ? endMatch[1] : defaults.endHour,
      endMinute: endMatch ? endMatch[2] : defaults.endMinute,
    };
  };

  normalizeHorarioPart = (partType, value, fallback) => {
    const digits = `${value || ""}`.replace(/\D/g, "").slice(0, 2);
    if (!digits) {
      return fallback;
    }

    let numeric = parseInt(digits, 10);
    if (isNaN(numeric)) {
      return fallback;
    }

    if (partType === "hour") {
      if (numeric < 1) numeric = 1;
      if (numeric > 12) numeric = 12;
    } else {
      if (numeric < 0) numeric = 0;
      if (numeric > 59) numeric = 59;
    }

    return this.formatTwoDigits(numeric);
  };

  buildHorarioDisplayText = (field, config) => {
    const map = this.getHorarioPartMap(field);
    return `${config[map.startHour]}:${config[map.startMinute]} AM - ${
      config[map.endHour]
    }:${config[map.endMinute]} PM`;
  };

  buildHorarioMeridiemTextFromConfig = (field, config) => {
    const map = this.getHorarioPartMap(field);
    const defaults = this.getDefaultHorarioParts(field);
    const startHour = this.normalizeHorarioPart(
      "hour",
      config[map.startHour],
      defaults.startHour,
    );
    const startMinute = this.normalizeHorarioPart(
      "minute",
      config[map.startMinute],
      defaults.startMinute,
    );
    const endHour = this.normalizeHorarioPart(
      "hour",
      config[map.endHour],
      defaults.endHour,
    );
    const endMinute = this.normalizeHorarioPart(
      "minute",
      config[map.endMinute],
      defaults.endMinute,
    );
    return `${startHour}:${startMinute} AM - ${endHour}:${endMinute} PM`;
  };

  handleHorarioPartChange = (field, partKey, value) => {
    const map = this.getHorarioPartMap(field);
    if (this.state.config[map.closed]) {
      return;
    }

    const currentConfig = this.state.config;
    const cleanValue = `${value || ""}`.replace(/\D/g, "").slice(0, 2);
    const nextConfig = {
      ...currentConfig,
      [partKey]: cleanValue,
    };
    nextConfig[field] = this.buildHorarioDisplayText(field, nextConfig);

    this.setState({ config: nextConfig });
  };

  handleHorarioPartBlur = (field, partType, partKey, defaultValue) => {
    const map = this.getHorarioPartMap(field);
    if (this.state.config[map.closed]) {
      return;
    }

    const currentConfig = this.state.config;
    const normalizedValue = this.normalizeHorarioPart(
      partType,
      currentConfig[partKey],
      defaultValue,
    );
    const nextConfig = {
      ...currentConfig,
      [partKey]: normalizedValue,
    };
    nextConfig[field] = this.buildHorarioDisplayText(field, nextConfig);

    this.setState({ config: nextConfig });
  };

  handleHorarioClosedToggle = (field) => {
    const map = this.getHorarioPartMap(field);
    const currentConfig = this.state.config;
    const isClosed = !!currentConfig[map.closed];
    const defaults = this.getDefaultHorarioParts(field);

    const nextConfig = {
      ...currentConfig,
      [map.closed]: !isClosed,
    };

    if (isClosed) {
      nextConfig[map.startHour] =
        currentConfig[map.startHour] || defaults.startHour;
      nextConfig[map.startMinute] =
        currentConfig[map.startMinute] || defaults.startMinute;
      nextConfig[map.endHour] = currentConfig[map.endHour] || defaults.endHour;
      nextConfig[map.endMinute] =
        currentConfig[map.endMinute] || defaults.endMinute;
      nextConfig[field] = this.buildHorarioDisplayText(field, nextConfig);
    } else {
      nextConfig[field] = "CERRADO";
    }

    this.setState({ config: nextConfig });
  };

  renderHorarioNumericField = (field, label) => {
    const { config } = this.state;
    const map = this.getHorarioPartMap(field);
    const defaults = this.getDefaultHorarioParts(field);
    const isClosed = !!config[map.closed];

    return (
      <div className="column is-4">
        <label className="label">{label}</label>
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          {isClosed ? (
            <input className="input" value="CERRADO" disabled />
          ) : (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
                width: "100%",
                minWidth: 0,
              }}
            >
              <input
                className="input"
                style={{
                  width: "48px",
                  textAlign: "center",
                  paddingLeft: "0",
                  paddingRight: "0",
                }}
                maxLength={2}
                inputMode="numeric"
                value={config[map.startHour]}
                onChange={(e) =>
                  this.handleHorarioPartChange(
                    field,
                    map.startHour,
                    e.target.value,
                  )
                }
                onBlur={() =>
                  this.handleHorarioPartBlur(
                    field,
                    "hour",
                    map.startHour,
                    defaults.startHour,
                  )
                }
              />
              <span>:</span>
              <input
                className="input"
                style={{
                  width: "48px",
                  textAlign: "center",
                  paddingLeft: "0",
                  paddingRight: "0",
                }}
                maxLength={2}
                inputMode="numeric"
                value={config[map.startMinute]}
                onChange={(e) =>
                  this.handleHorarioPartChange(
                    field,
                    map.startMinute,
                    e.target.value,
                  )
                }
                onBlur={() =>
                  this.handleHorarioPartBlur(
                    field,
                    "minute",
                    map.startMinute,
                    defaults.startMinute,
                  )
                }
              />
              <span style={{ minWidth: "22px", fontSize: "0.9rem" }}>AM</span>
              <span>-</span>
              <input
                className="input"
                style={{
                  width: "48px",
                  textAlign: "center",
                  paddingLeft: "0",
                  paddingRight: "0",
                }}
                maxLength={2}
                inputMode="numeric"
                value={config[map.endHour]}
                onChange={(e) =>
                  this.handleHorarioPartChange(
                    field,
                    map.endHour,
                    e.target.value,
                  )
                }
                onBlur={() =>
                  this.handleHorarioPartBlur(
                    field,
                    "hour",
                    map.endHour,
                    defaults.endHour,
                  )
                }
              />
              <span>:</span>
              <input
                className="input"
                style={{
                  width: "48px",
                  textAlign: "center",
                  paddingLeft: "0",
                  paddingRight: "0",
                }}
                maxLength={2}
                inputMode="numeric"
                value={config[map.endMinute]}
                onChange={(e) =>
                  this.handleHorarioPartChange(
                    field,
                    map.endMinute,
                    e.target.value,
                  )
                }
                onBlur={() =>
                  this.handleHorarioPartBlur(
                    field,
                    "minute",
                    map.endMinute,
                    defaults.endMinute,
                  )
                }
              />
              <span style={{ minWidth: "22px", fontSize: "0.9rem" }}>PM</span>
            </div>
          )}

          <label
            className="checkbox"
            style={{ whiteSpace: "nowrap", alignSelf: "flex-end" }}
          >
            <input
              type="checkbox"
              checked={isClosed}
              onChange={() => this.handleHorarioClosedToggle(field)}
            />{" "}
            Cerrado
          </label>
        </div>
      </div>
    );
  };

  normalizeSchedules = (schedules, caffenio) => {
    const driveId = this.getDriveId(caffenio);
    return schedules
      .map((row, index) => ({
        ScheduleId: row.ScheduleId || row.scheduleId || row.Id || index + 1,
        DriveId: row.DriveId || row.driveId || driveId,
        DayOfWeek: parseInt(
          row.DayOfWeek || row.dayOfWeek || row.Day || index + 1,
          10,
        ),
        DayName:
          row.DayName ||
          row.dayName ||
          this.getDayName(
            parseInt(
              row.DayOfWeek || row.dayOfWeek || row.Day || index + 1,
              10,
            ),
          ),
        StartTime: this.normalizeTime(row.StartTime || row.startTime),
        EndTime: this.normalizeTime(row.EndTime || row.endTime),
      }))
      .sort((a, b) => a.DayOfWeek - b.DayOfWeek);
  };

  loadHorariosFromApi = async (driveId) => {
    if (!driveId) return;

    this.setState({ loadingHorarios: true });
    try {
      const response = await SoporteToolsAPI.getPdvHorarios(driveId);
      const payload = response && response.data ? response.data : null;
      if (!payload) return;

      const venueCandidate = payload.DriveVenue || payload.driveVenue || {};
      const venue = Array.isArray(venueCandidate)
        ? venueCandidate[0] || {}
        : venueCandidate;
      const schedulesResponse = payload.Schedules || payload.schedules || [];
      const normalizedSchedules = this.normalizeSchedules(schedulesResponse, {
        id: driveId,
      });
      const schedules = normalizedSchedules.filter((item) => {
        const scheduleId = parseInt(item.ScheduleId, 10);
        return !isNaN(scheduleId) && scheduleId > 0;
      });
      const currentConfig = this.state.config;

      const mondayFridayStart =
        venue.MondayToFridayStartTime || venue.mondayToFridayStartTime;
      const mondayFridayEnd =
        venue.MondayToFridayEndTime || venue.mondayToFridayEndTime;
      const saturdayStart = venue.SaturdayStartTime || venue.saturdayStartTime;
      const saturdayEnd = venue.SaturdayEndTime || venue.saturdayEndTime;
      const sundayStart = venue.SundayStartTime || venue.sundayStartTime;
      const sundayEnd = venue.SundayEndTime || venue.sundayEndTime;

      const hasMondayFridayStored = this.hasStoredRange(
        mondayFridayStart,
        mondayFridayEnd,
      );
      const hasSaturdayStored = this.hasStoredRange(saturdayStart, saturdayEnd);
      const hasSundayStored = this.hasStoredRange(sundayStart, sundayEnd);

      const mondayFridayParts = hasMondayFridayStored
        ? this.extractHorarioPartsFromTimes(
            "horarioLunesViernes",
            mondayFridayStart,
            mondayFridayEnd,
          )
        : { startHour: "", startMinute: "", endHour: "", endMinute: "" };
      const saturdayParts = hasSaturdayStored
        ? this.extractHorarioPartsFromTimes(
            "horarioSabado",
            saturdayStart,
            saturdayEnd,
          )
        : { startHour: "", startMinute: "", endHour: "", endMinute: "" };
      const sundayParts = hasSundayStored
        ? this.extractHorarioPartsFromTimes(
            "horarioDomingo",
            sundayStart,
            sundayEnd,
          )
        : { startHour: "", startMinute: "", endHour: "", endMinute: "" };

      const mondayFridayClosed =
        hasMondayFridayStored &&
        this.isClosedRange(mondayFridayStart, mondayFridayEnd);
      const saturdayClosed =
        hasSaturdayStored && this.isClosedRange(saturdayStart, saturdayEnd);
      const sundayClosed =
        hasSundayStored && this.isClosedRange(sundayStart, sundayEnd);

      const config = {
        ...currentConfig,
        driveVenueId: venue.DriveVenueId || venue.driveVenueId || 0,
        latitud:
          venue.Latitude !== undefined && venue.Latitude !== null
            ? venue.Latitude
            : venue.latitude !== undefined && venue.latitude !== null
            ? venue.latitude
            : currentConfig.latitud,
        longitud:
          venue.Longitude !== undefined && venue.Longitude !== null
            ? venue.Longitude
            : venue.longitude !== undefined && venue.longitude !== null
            ? venue.longitude
            : currentConfig.longitud,
        ciudad:
          venue.City !== undefined && venue.City !== null
            ? venue.City
            : venue.city !== undefined && venue.city !== null
            ? venue.city
            : currentConfig.ciudad,
        estado:
          venue.State !== undefined && venue.State !== null
            ? venue.State
            : venue.state !== undefined && venue.state !== null
            ? venue.state
            : currentConfig.estado,
        direccion:
          venue.VenueAddress !== undefined && venue.VenueAddress !== null
            ? venue.VenueAddress
            : venue.venueAddress !== undefined && venue.venueAddress !== null
            ? venue.venueAddress
            : currentConfig.direccion,
        horarioLunesViernes: mondayFridayClosed
          ? "CERRADO"
          : hasMondayFridayStored
          ? this.formatRangeForInput(mondayFridayStart, mondayFridayEnd)
          : "",
        horarioSabado: saturdayClosed
          ? "CERRADO"
          : hasSaturdayStored
          ? this.formatRangeForInput(saturdayStart, saturdayEnd)
          : "",
        horarioDomingo: sundayClosed
          ? "CERRADO"
          : hasSundayStored
          ? this.formatRangeForInput(sundayStart, sundayEnd)
          : "",
        horarioLunesViernesStartHour: mondayFridayParts.startHour,
        horarioLunesViernesStartMinute: mondayFridayParts.startMinute,
        horarioLunesViernesEndHour: mondayFridayParts.endHour,
        horarioLunesViernesEndMinute: mondayFridayParts.endMinute,
        horarioLunesViernesCerrado: mondayFridayClosed,
        horarioSabadoStartHour: saturdayParts.startHour,
        horarioSabadoStartMinute: saturdayParts.startMinute,
        horarioSabadoEndHour: saturdayParts.endHour,
        horarioSabadoEndMinute: saturdayParts.endMinute,
        horarioSabadoCerrado: saturdayClosed,
        horarioDomingoStartHour: sundayParts.startHour,
        horarioDomingoStartMinute: sundayParts.startMinute,
        horarioDomingoEndHour: sundayParts.endHour,
        horarioDomingoEndMinute: sundayParts.endMinute,
        horarioDomingoCerrado: sundayClosed,
        mobileEnabled:
          venue.Active !== undefined && venue.Active !== null
            ? !!venue.Active
            : venue.active !== undefined && venue.active !== null
            ? !!venue.active
            : venue.SalesOnLine !== undefined && venue.SalesOnLine !== null
            ? !!venue.SalesOnLine
            : venue.salesOnLine !== undefined && venue.salesOnLine !== null
            ? !!venue.salesOnLine
            : currentConfig.mobileEnabled,
        driveCartActivated:
          venue.DriveCartActivated !== undefined &&
          venue.DriveCartActivated !== null
            ? !!venue.DriveCartActivated
            : venue.driveCartActivated !== undefined &&
              venue.driveCartActivated !== null
            ? !!venue.driveCartActivated
            : !!currentConfig.driveCartActivated,
        caffenioType:
          venue.VenueType !== undefined && venue.VenueType !== null
            ? this.normalizeVenueType(venue.VenueType, "1")
            : venue.venueType !== undefined && venue.venueType !== null
            ? this.normalizeVenueType(venue.venueType, "1")
            : payload.VenueType !== undefined && payload.VenueType !== null
            ? this.normalizeVenueType(payload.VenueType, "1")
            : payload.venueType !== undefined && payload.venueType !== null
            ? this.normalizeVenueType(payload.venueType, "1")
            : this.normalizeVenueType(currentConfig.caffenioType, "1"),
      };

      this.setState({
        config,
        schedules,
      });
    } catch (error) {
      toast.warn("No fue posible cargar horarios guardados.");
    } finally {
      this.setState({ loadingHorarios: false });
    }
  };

  saveHorariosToApi = async (successMessage) => {
    const { caffenio } = this.state;
    const driveId = this.getDriveId(caffenio);
    if (!driveId) {
      toast.warn("No se encontró identificador de punto de venta.");
      return;
    }

    const payload = this.buildDriveVenuePayload();
    try {
      const response = await SoporteToolsAPI.putPdvHorarios(driveId, payload);
      const data = response && response.data ? response.data : null;
      if (data && (data.Schedules || data.schedules)) {
        const normalizedSchedules = this.normalizeSchedules(
          data.Schedules || data.schedules,
          caffenio,
        );
        const schedules = normalizedSchedules.filter((item) => {
          const scheduleId = parseInt(item.ScheduleId, 10);
          return !isNaN(scheduleId) && scheduleId > 0;
        });
        this.setState({ schedules });
      }
      toast.success(successMessage);
    } catch (error) {
      const serverMessage =
        error && error.response && error.response.data
          ? error.response.data.Message || error.response.data.message
          : null;
      toast.error(
        serverMessage || "No fue posible guardar la configuración de horarios.",
      );
    }
  };

  getTimeOptions = () => {
    const options = [];
    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute += 15) {
        const hh = `${hour}`.padStart(2, "0");
        const mm = `${minute}`.padStart(2, "0");
        options.push(`${hh}:${mm}:00`);
      }
    }
    return options;
  };

  handleConfigChange = (field, value) => {
    this.setState({
      config: {
        ...this.state.config,
        [field]: value,
      },
    });
  };

  handleToggleMobile = () => {
    this.setState({
      config: {
        ...this.state.config,
        mobileEnabled: !this.state.config.mobileEnabled,
      },
    });
  };

  handleToggleDriveCart = () => {
    this.setState({
      config: {
        ...this.state.config,
        driveCartActivated: !this.state.config.driveCartActivated,
      },
    });
  };

  openEditScheduleModal = (schedule) => {
    this.setState({
      showEditScheduleModal: true,
      editingSchedule: schedule,
      editStartTime: schedule.StartTime,
      editEndTime: schedule.EndTime,
    });
  };

  closeEditScheduleModal = () => {
    this.setState({
      showEditScheduleModal: false,
      editingSchedule: null,
      editStartTime: "06:00:00",
      editEndTime: "22:00:00",
    });
  };

  buildDriveVenuePayload = () => {
    const { caffenio, config } = this.state;
    const mondayFriday = config.horarioLunesViernesCerrado
      ? { StartTime: "00:00:00", EndTime: "00:00:00" }
      : this.parseRangeToTimes(
          this.buildHorarioMeridiemTextFromConfig(
            "horarioLunesViernes",
            config,
          ),
          "06:00:00",
          "22:00:00",
        );
    const saturday = config.horarioSabadoCerrado
      ? { StartTime: "00:00:00", EndTime: "00:00:00" }
      : this.parseRangeToTimes(
          this.buildHorarioMeridiemTextFromConfig("horarioSabado", config),
          "06:00:00",
          "22:00:00",
        );
    const sunday = config.horarioDomingoCerrado
      ? { StartTime: "00:00:00", EndTime: "00:00:00" }
      : this.parseRangeToTimes(
          this.buildHorarioMeridiemTextFromConfig("horarioDomingo", config),
          "07:00:00",
          "22:00:00",
        );

    return {
      DriveVenue: {
        DriveVenueId: config.driveVenueId || 0,
        DriveId: this.getDriveId(caffenio),
        Latitude: parseFloat(config.latitud || 0),
        Longitude: parseFloat(config.longitud || 0),
        City: config.ciudad ? `${config.ciudad}`.trim() : null,
        State: config.estado ? `${config.estado}`.trim() : null,
        VenueAddress: config.direccion ? `${config.direccion}`.trim() : null,
        DriveCartActivated: !!config.driveCartActivated,
        MondayToFridayStartTime: mondayFriday.StartTime,
        MondayToFridayEndTime: mondayFriday.EndTime,
        SaturdayStartTime: saturday.StartTime,
        SaturdayEndTime: saturday.EndTime,
        SundayStartTime: sunday.StartTime,
        SundayEndTime: sunday.EndTime,
        Active: !!config.mobileEnabled,
        VenueType: 1,
      },
      Schedules: this.state.schedules.map((row) =>
        this.buildSchedulePayload(row),
      ),
    };
  };

  isClosedSchedule = (schedule) => {
    return schedule.StartTime === "00:00:00" && schedule.EndTime === "00:00:00";
  };

  getDefaultScheduleRange = (dayOfWeek) => {
    if (dayOfWeek === 1) {
      return { StartTime: "07:00:00", EndTime: "22:00:00" };
    }
    return { StartTime: "06:00:00", EndTime: "22:00:00" };
  };

  requestToggleDayStatus = (schedule) => {
    const isClosed = this.isClosedSchedule(schedule);
    this.setState({
      showToggleDayConfirm: true,
      toggleDayData: {
        schedule,
        action: isClosed ? "open" : "close",
      },
    });
  };

  cancelToggleDayStatus = () => {
    this.setState({
      showToggleDayConfirm: false,
      toggleDayData: null,
    });
  };

  confirmToggleDayStatus = async () => {
    const { toggleDayData } = this.state;
    if (!toggleDayData || !toggleDayData.schedule) {
      this.cancelToggleDayStatus();
      return;
    }

    const { schedule, action } = toggleDayData;
    const defaultRange = this.getDefaultScheduleRange(schedule.DayOfWeek);

    const schedules = this.state.schedules.map((row) => {
      if (row.DayOfWeek !== schedule.DayOfWeek) {
        return row;
      }

      if (action === "close") {
        return {
          ...row,
          StartTime: "00:00:00",
          EndTime: "00:00:00",
        };
      }

      return {
        ...row,
        StartTime: defaultRange.StartTime,
        EndTime: defaultRange.EndTime,
      };
    });

    this.setState({ schedules }, async () => {
      await this.saveHorariosToApi(
        action === "close"
          ? "Día cerrado correctamente."
          : "Día reabierto con horario predeterminado.",
      );
      this.cancelToggleDayStatus();
    });
  };

  buildSchedulePayload = (row) => {
    return {
      ScheduleId: row.ScheduleId,
      DriveId: row.DriveId,
      DayOfWeek: row.DayOfWeek,
      StartTime: row.StartTime,
      EndTime: row.EndTime,
      IsClose: row.StartTime === "00:00:00" && row.EndTime === "00:00:00",
    };
  };

  updateDriveVenue = async () => {
    await this.saveHorariosToApi("Configuración de DriveVenue actualizada.");
  };

  updateSelectedSchedule = async () => {
    const { editingSchedule, editStartTime, editEndTime } = this.state;
    if (!editingSchedule) {
      return;
    }

    if (editStartTime >= editEndTime) {
      toast.warn("La hora de inicio debe ser menor a la hora fin.");
      return;
    }

    const schedules = this.state.schedules.map((row) => {
      if (row.DayOfWeek === editingSchedule.DayOfWeek) {
        return {
          ...row,
          StartTime: editStartTime,
          EndTime: editEndTime,
        };
      }
      return row;
    });

    this.setState({ schedules }, async () => {
      await this.saveHorariosToApi("Horario actualizado correctamente.");
      this.closeEditScheduleModal();
    });
  };

  render() {
    const {
      caffenio,
      config,
      schedules,
      loadingHorarios,
      showEditScheduleModal,
      editingSchedule,
      editStartTime,
      editEndTime,
      showToggleDayConfirm,
      toggleDayData,
    } = this.state;
    const timeOptions = this.getTimeOptions();

    return (
      <div>
        <div className="card">
          <div className="card-header">
            <div className="card-header-title is-size-4 center-text">
              <span
                style={{ position: "absolute", left: 25 }}
                className="is-primary tooltip"
                data-tooltip="Ir Atrás"
              >
                <i
                  className="fa fa-arrow-left"
                  style={{ cursor: "pointer", color: "#91BA43" }}
                  onClick={() => this.props.history.goBack()}
                />
              </span>
              <div>Configuración de App Movil</div>
            </div>
          </div>
          <div className="card-content">
            <div className="columns is-multiline">
              <div className="column is-12">
                <h2 className="title is-4">
                  {" "}
                  {`${caffenio ? caffenio.nombre : "-"} | ID: ${this.getDriveId(
                    caffenio,
                  ) || "-"}`}{" "}
                </h2>
              </div>
              <div className="column is-4">
                <label className="label">Ciudad</label>
                <input
                  className="input"
                  value={config.ciudad}
                  onChange={(e) =>
                    this.handleConfigChange("ciudad", e.target.value)
                  }
                />
              </div>
              <div className="column is-4">
                <label className="label">Estado</label>
                <input
                  className="input"
                  value={config.estado}
                  onChange={(e) =>
                    this.handleConfigChange("estado", e.target.value)
                  }
                />
              </div>
              <div className="column is-4">
                <label className="label">Dirección</label>
                <input
                  className="input"
                  value={config.direccion}
                  onChange={(e) =>
                    this.handleConfigChange("direccion", e.target.value)
                  }
                />
              </div>

              <div className="column is-4">
                <label className="label">Latitud</label>
                <input
                  className="input"
                  value={config.latitud}
                  onChange={(e) =>
                    this.handleConfigChange("latitud", e.target.value)
                  }
                />
              </div>
              <div className="column is-4">
                <label className="label">Longitud</label>
                <input
                  className="input"
                  value={config.longitud}
                  onChange={(e) =>
                    this.handleConfigChange("longitud", e.target.value)
                  }
                />
              </div>
              <div className="column is-4"></div>

              {this.renderHorarioNumericField(
                "horarioLunesViernes",
                "Horario Lunes a Viernes",
              )}
              {this.renderHorarioNumericField(
                "horarioSabado",
                "Horario Sábado",
              )}
              {this.renderHorarioNumericField(
                "horarioDomingo",
                "Horario Domingo",
              )}
              <div className="column is-6">
                <div className="field is-horizontal">
                  <div className="field-body">
                    <input
                      id="mobileEnabled"
                      type="checkbox"
                      className="switch"
                      checked={config.mobileEnabled}
                      onChange={() => {}}
                    />
                    <label
                      htmlFor="mobileEnabled"
                      onClick={(e) => {
                        e.stopPropagation();
                        this.handleToggleMobile();
                      }}
                    >
                      ¿Habilitar ventas en línea?
                    </label>
                  </div>
                </div>
              </div>
              <div className="column is-6">
                <div className="field is-horizontal">
                  <div className="field-body">
                    <input
                      id="driveCartActivated"
                      type="checkbox"
                      className="switch"
                      checked={config.driveCartActivated}
                      onChange={() => {}}
                    />
                    <label
                      htmlFor="driveCartActivated"
                      onClick={(e) => {
                        e.stopPropagation();
                        this.handleToggleDriveCart();
                      }}
                    >
                      ¿Cuenta con carril exclusivo?
                    </label>
                  </div>
                </div>
              </div>
              <div className="column is-12 has-text-right">
                <button
                  className="button is-success"
                  onClick={this.updateDriveVenue}
                >
                  <span className="icon is-small">
                    <i className="fa fa-save" />
                  </span>
                  <span>Actualizar DriveVenue</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <br />

        <div className="card">
          <div className="card-content">
            <div className="columns is-multiline">
              <div className="column is-12">
                <h2 className="title is-4">
                  🗓️ Horarios existentes (Schedule)
                </h2>
              </div>
              {!loadingHorarios && schedules.length === 0 && (
                <div className="column is-12">
                  <article className="message is-info">
                    <div className="message-header">
                      <p>Info</p>
                    </div>
                    <div className="message-body">
                      Este drive aún no tiene configurados sus horarios.
                    </div>
                  </article>
                </div>
              )}
              {schedules.length > 0 && (
                <div className="column is-12">
                  <table className="table is-fullwidth is-striped is-bordered">
                    <thead>
                      <tr>
                        <th>ScheduleId</th>
                        <th>DriveId</th>
                        <th>Dia de la Semana</th>
                        <th>Nombre del día</th>
                        <th>Hora inicio</th>
                        <th>Hora fin</th>
                        <th>Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {schedules.map((row, index) => (
                        <tr key={`${row.DayOfWeek}-${index}`}>
                          <td>{row.ScheduleId}</td>
                          <td>{row.DriveId}</td>
                          <td>{row.DayOfWeek}</td>
                          <td>{row.DayName}</td>
                          <td>{row.StartTime}</td>
                          <td>{row.EndTime}</td>
                          <td>
                            <button
                              className="button is-small is-info"
                              onClick={() => this.openEditScheduleModal(row)}
                            >
                              Editar
                            </button>
                            <button
                              className={`button is-small ${
                                this.isClosedSchedule(row)
                                  ? "is-success"
                                  : "is-warning"
                              }`}
                              style={{ marginLeft: "8px" }}
                              onClick={() => this.requestToggleDayStatus(row)}
                            >
                              {this.isClosedSchedule(row)
                                ? "Abrir día"
                                : "Cerrar día"}
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
              <div className="column is-12 has-text-right">
                <button
                  className="button is-light"
                  onClick={() => this.props.history.push("/puntos-de-venta")}
                >
                  Regresar
                </button>
              </div>{" "}
            </div>
          </div>
        </div>

        {showEditScheduleModal && editingSchedule && (
          <div className="modal is-active">
            <div
              className="modal-background"
              onClick={this.closeEditScheduleModal}
            />
            <div className="modal-card">
              <header className="modal-card-head">
                <p className="modal-card-title">Editar horario</p>
                <button
                  className="delete"
                  aria-label="close"
                  onClick={this.closeEditScheduleModal}
                />
              </header>
              <section className="modal-card-body">
                <p>
                  <strong>{editingSchedule.DayName}</strong>
                </p>
                <br />
                <div className="field">
                  <label className="label">Hora inicio</label>
                  <div className="control">
                    <div className="select is-fullwidth">
                      <select
                        value={editStartTime}
                        onChange={(e) =>
                          this.setState({ editStartTime: e.target.value })
                        }
                      >
                        {timeOptions.map((t) => (
                          <option key={`modal-start-${t}`} value={t}>
                            {t.substring(0, 5)}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="field">
                  <label className="label">Hora fin</label>
                  <div className="control">
                    <div className="select is-fullwidth">
                      <select
                        value={editEndTime}
                        onChange={(e) =>
                          this.setState({ editEndTime: e.target.value })
                        }
                      >
                        {timeOptions.map((t) => (
                          <option key={`modal-end-${t}`} value={t}>
                            {t.substring(0, 5)}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </section>
              <footer className="modal-card-foot">
                <button
                  className="button is-success"
                  onClick={this.updateSelectedSchedule}
                >
                  Guardar
                </button>
                <button
                  className="button"
                  onClick={this.closeEditScheduleModal}
                >
                  Cancelar
                </button>
              </footer>
            </div>
          </div>
        )}

        {showToggleDayConfirm && toggleDayData && (
          <AcceptModal
            modalTitle="Confirmar"
            modalBody={
              <p>
                {toggleDayData.action === "close"
                  ? `¿Está seguro que desea cerrar el punto de venta todo el día ${toggleDayData.schedule.DayName}?`
                  : `¿Está seguro que desea reabrir el día ${toggleDayData.schedule.DayName} con horario predeterminado?`}
              </p>
            }
            isActive={showToggleDayConfirm}
            willSave
            done={this.confirmToggleDayStatus}
            cancel={this.cancelToggleDayStatus}
          />
        )}
      </div>
    );
  }
}
